module.exports = __webpack_public_path__ + "img/dataservice_flyzgzry.cb86cfb0.png";